import { memo, useMemo, useState } from 'react';
import { tano } from '../../utils/tanoEngine';
import { buildTanoOptions } from '../../utils/tanoSkins';
import TanoRobot from './TanoRobot';

/**
 * Personnage Tano — rendu ROBOT (image webp + overlays SVG, cf. TanoRobot).
 * L'ancien moteur SVG tuit-tuit reste le FALLBACK technique si l'image ne
 * charge pas (offline, asset manquant) : jamais d'espace vide pour l'élève.
 *
 * @param {string} [mood='idle'] - 'idle' | 'joy' | 'sad' | 'angry' | 'sleep'
 * @param {string} [plume] / [acc] / [aura] - ids de skin (API) ; vide → base / pas d'accessoire
 * @param {number} [size=120] - taille en px
 * @param {boolean} [reactive=false] - joue l'anim de réaction (rebond joy / affaissement sad) au lieu du simple idle
 */
const TanoCharacter = memo(function TanoCharacter({ mood = 'idle', plume, acc, aura, size = 120, reactive = false }) {
  const [legacy, setLegacy] = useState(false);
  const classes = `flex-shrink-0${reactive ? ` tano-react-${mood}` : ''}`;
  const htmlLegacy = useMemo(
    () => (legacy ? tano(buildTanoOptions({ plume, acc, aura, mood })) : null),
    [legacy, plume, acc, aura, mood],
  );

  if (legacy) {
    return (
      <div
        className={classes}
        style={{ width: size, height: size }}
        // eslint-disable-next-line react/no-danger -- contenu SVG statique généré depuis des ids contrôlés
        dangerouslySetInnerHTML={{ __html: htmlLegacy }}
      />
    );
  }
  return (
    <div className={classes} style={{ width: size, height: size }}>
      <TanoRobot mood={mood} plume={plume} acc={acc} aura={aura} onErreur={() => setLegacy(true)} />
    </div>
  );
});

export default TanoCharacter;
